// extracted by mini-css-extract-plugin
export default {"modal":"CooldownModal_modal__3TQCo","text":"CooldownModal_text__-RRuO","button":"CooldownModal_button__jCYFY","buttonContainer":"CooldownModal_buttonContainer__dYa3U"};